import { toast, ToastOptions } from 'react-toastify';

import { REACT_TOASTIFY_API_ERROR_ID } from '@/shared/redux/api/base-api.constants';

export const showToastError = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.error(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastSuccess = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.success(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastWarning = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.warning(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

export const showToastInfo = (
  message: string,
  options?: Omit<ToastOptions, 'toastId' | 'type'>,
): void => {
  toast.info(message, {
    ...options,
    toastId: REACT_TOASTIFY_API_ERROR_ID,
  });
};

// Caller-owned toastId (not the shared API-error id) so it can be updated in place.
export const showToastLoading = (message: string, toastId: string): void => {
  toast.loading(message, { toastId });
};
